{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Изберете предмет",
  "tableResizer": "Преоразмерител",
  "colorSwatchPicker": "Color swatches"
}
